import {BrandPageContent} from '../../../brand/components/BrandPage'
import {featuresCopilotPage} from './content'
import {PlanTypeContextProvider} from './_context/PlanTypeContext'

import styles from './styles.module.css'

import {ContentfulSubnav} from '@github-ui/swp-core/components/contentful/ContentfulSubnav'

import {HeroSection} from './_sections/HeroSection/HeroSection'
import {FeaturesSection} from './_sections/FeaturesSection/FeaturesSection'
import {ModelsSection} from './_sections/ModelsSection/ModelsSection'
import {SetupSection} from './_sections/SetupSection/SetupSection'
import {ResourcesSection} from './_sections/ResourcesSection/ResourcesSection'
import {PricingSection} from './_sections/PricingSection/PricingSection'
import {CtaSection} from './_sections/CtaSection/CtaSection'
import {FaqSection} from './_sections/FaqSection/FaqSection'
import {FootnotesSection} from './_sections/FootnotesSection/FootnotesSection'

export default function FeaturesCopilotIndex() {
  const withFootnotes = true

  return (
    <BrandPageContent
      definition={featuresCopilotPage}
      className={styles.Page}
      withFootnotes={withFootnotes}
      wrapTheme={theme => <PlanTypeContextProvider>{theme}</PlanTypeContextProvider>}
    >
      {({subnav, hero, features, models, setup, resources, pricing, cta, faq}) => (
        <>
          {subnav ? <ContentfulSubnav component={subnav} /> : null}

          {/* Sections */}
          {hero ? <HeroSection contentfulContent={hero} hasSubnav={!!subnav} /> : null}
          {features ? <FeaturesSection contentfulContent={features} /> : null}
          {models ? <ModelsSection contentfulContent={models} /> : null}
          {setup ? <SetupSection contentfulContent={setup} /> : null}
          {resources ? <ResourcesSection contentfulContent={resources} /> : null}
          {pricing ? <PricingSection contentfulContent={pricing} /> : null}
          {cta ? <CtaSection contentfulContent={cta} /> : null}
          {faq ? <FaqSection contentfulContent={faq} /> : null}

          {withFootnotes ? <FootnotesSection /> : null}
        </>
      )}
    </BrandPageContent>
  )
}
